module.exports = "/assets/a54ad5bf944cafa79e4da552161c40e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/9C.png
// module id = 2285
// module chunks = 0